import DocumentList from './DocumentList'

export default DocumentList;